module.exports = __webpack_public_path__ + "img/portfolio-details5.793d4acf.png";